import ApiRequest from '../util/ApiRequest'

export default class MemberTsn {
    getAll = async () => {
        return await ApiRequest.set('v1/member-tsns', 'GET')
    }
    getSelfRegister = async (body) => {
        return await ApiRequest.set('v1/member-tsn/self', 'GET')
    }

    getByMemberAndTsn = async (member_id, tsn_id) => {
        return await ApiRequest.set(`v1/member-tsn/member/${member_id}/tsn/${tsn_id}`, 'GET')
    }
}
